import React, { FC } from 'react';
import { ReactComponent as ConnectionLostIcon } from '@blink/assets/src/icons/connectionLost.svg';
import { useDispatch } from 'react-redux';

import { Button, ButtonVariant } from '@/shared/ui';

type ServerErrorProps = {
    title?: string;
    description?: string;
    action: any;
};

export const ServerError: FC<ServerErrorProps> = ({
    title = 'Something went wrong',
    description = `We couldn't load due to an internal error. Please try again later.`,
    action = () => {},
}) => {
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(action());
    };

    return (
        <div className='flex flex-col items-center self-stretch min-w-[368px] p-[32px_48px] border border-opaque bg-background-primary'>
            <div className='flex items-center gap-[10px] pb-5'>
                <ConnectionLostIcon />
            </div>
            <div className='flex flex-col items-center self-stretch gap-3'>
                <div className='text-content-primary text-center font-inter font-semibold leading-[20px] tracking-[-0.48px]'>
                    {title}
                </div>
                <div className='flex flex-col items-center gap-[10px] self-stretch text-content-secondary text-center font-inter font-normal leading-[20px] tracking-[-0.48px]'>
                    {description}
                </div>
            </div>
            <div className='flex flex-col items-center self-stretch pt-7 gap-[10px]'>
                <Button variant={ButtonVariant.Secondary} onClick={handleClick}>
                    Try again
                </Button>
            </div>
        </div>
    );
};
